export default IconCurrencyFrank => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-currency-frank" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M17 5h-6a2 2 0 0 0 -2 2v12" />
  <path d="M7 15h4" />
  <path d="M9 11h7" />
</svg>`;